<div class="boost-shift-wrapper" *ngIf="boostVisibility?.sureShift || boostVisibility?.boostButton">
  <form [formGroup]="boostForm">
    <div class="boost-shift-title">
      <label>Boost Your Shift(s)</label>
      <button *ngIf="!autoToggle" (click)="toggleBoostOptions()">
        <i class="fas" [ngClass]="!showBoostOptions ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
      </button>
    </div>
    <div>
      <p class="optional-text">(OPTIONAL)</p>
    </div>
    <div class="boost-shift-subtitle">
      <label>Increase the likelihood of your shifts being filled by using our boost options.</label>
    </div>
    <hr *ngIf="showBoostOptions">
    <div *ngIf="!!showBoostOptions && boostVisibility" class="boost-details" id="boost-card">
      <div class="boost-form" fxFlex="0 0 80%" fxLayout="column" fxLayoutGap="15px">
        <ng-container *ngIf="boostVisibility?.boostButton">
          <h2 class="boost-shift-heading">
            <i class="fal fa-rocket"></i>
            <span> Rate Boost </span>
            <i matTooltip="Increase the likelihood of your shift being filled by boosting the hourly rates."
               matTooltipPosition="above" matTooltipClass="tooltip short-tooltip"
               class="far fa-info-circle info-icon"></i>
          </h2>
          <mat-form-field appearance="outline" class="mat-form-field-wrapper">
            <mat-label>Boost Amount</mat-label>
            <mat-select formControlName="boostAmount" [attr.automation-id]="'confirm-cart-sidebar-boost-amount-dropdown'">
              <mat-option *ngFor="let boost of boostRangeList" [value]="boost">Boost {{ boost }}%</mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>

        <ng-container *ngIf="boostVisibility?.boostButton">
          <h2 class="boost-shift-heading">
            <!-- <i class="fas fa-history icon-flipped"></i>  -->
            <img src="../assets/images/overtime.svg" alt="Overtime Boost"/>
            <span> Overtime Boost </span>
            <i matTooltip="Allow overtime to IntelyPros to expand this shift for more IntelyPros."
               matTooltipPosition="above" matTooltipClass="tooltip short-tooltip"
               class="far fa-info-circle info-icon"></i>
          </h2>

          <mat-form-field class="modify-form-wrapper" appearance="outline" [floatLabel]="'always'">
            <mat-label>Allow Overtime</mat-label>
            <mat-select formControlName="allowOvertime"
                        [disabled]="!boostForm.get('boostAmount').value"
                        automation-id="modify-boost-overtime"
                        placeholder="Allow Overtime"
                        [attr.automation-id]="'confirm-cart-sidebar-allow-overtime-dropdown'">
              <mat-select-trigger class="overtime-setting">
                {{ getSelectedText(boostForm.get('allowOvertime').value) }}
              </mat-select-trigger>
              <ng-container [ngSwitch]="overtimeSettingValue">
                <ng-container *ngSwitchCase="'allFac'">
                  <mat-option value="allFac">If working 40+ hours for IntelyCare</mat-option>
                </ng-container>
                <ng-container *ngSwitchCase="'myFac'">
                  <mat-option value="allFac">If working 40+ hours for IntelyCare</mat-option>
                  <mat-option value="myFac">If working 40+ hours at my facility</mat-option>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <mat-option value="allFac">If working 40+ hours for IntelyCare</mat-option>
                  <mat-option value="myFac">If working 40+ hours at my facility</mat-option>
                  <mat-option value="No">Don't allow overtime</mat-option>
                </ng-container>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </ng-container>

        <ng-container *ngIf="boostVisibility?.sureShift">
          <h2 class="boost-shift-heading">
            <i class="fas fa-shield-check"></i>
            <span> Sure Shift Boost </span>
            <i matTooltip="Reassure IntelyPros that you will not cancel this shift by applying this feature."
               matTooltipPosition="above" matTooltipClass="tooltip short-tooltip"
               class="far fa-info-circle info-icon"></i>
          </h2>
          <mat-checkbox formControlName="sureShift" class="checkbox-text">
            I understand by applying Sure Shift, I will not be able to cancel once an IntelyPro has accepted the
            shift(s).
          </mat-checkbox>
        </ng-container>

        <button *ngIf="!autoToggle" mat-button (click)="boostShifts(request)"
                [disabled]="(!boostForm.controls.boostAmount.value &&
                (!boostForm.controls.allowOvertime.value || !boostForm.controls.allowOvertime.value.value) &&
                 !boostForm.controls?.sureShift.value) || _modifyBoostService.processBoosting"
                [attr.automation-id]="'confirm-cart-sidebar-boost-shifts'">
          <ng-container *ngIf="_modifyBoostService.processBoosting else buttonLabels">
            <img src="/assets/images/loader.gif" height="30" width="30" />
          </ng-container>
          <ng-template #buttonLabels>
            Apply To All Shift(s)
          </ng-template>
        </button>
      </div>
    </div>
  </form>
</div>
